import { render, staticRenderFns } from "./QualidadeBot.vue?vue&type=template&id=06dc1c2a&scoped=true"
import script from "./QualidadeBot.vue?vue&type=script&lang=js"
export * from "./QualidadeBot.vue?vue&type=script&lang=js"
import style0 from "./QualidadeBot.vue?vue&type=style&index=0&id=06dc1c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc1c2a",
  null
  
)

export default component.exports